<div class="common-text-input__container"
  [id]="field.id">
  <div class="common-field-with-button__container-box"
    [ngClass]="{'common-field-with-button__container-box--error': field.error}"
    [attr.disabled]="field.noEditable?true:null">
    <div class="common-field-with-button__block-header">
      <div class="common-text-input__label-no-cursor">
        <span class="common-text-input__text-label">{{field.label}}</span>
        @if (field.required) {
          <span class="common-tag__mandatory-text-asterisk">*</span>
        }
        <div class="common-text-input__block-buttons">
          @if (field.references?.length) {
            <tooltip-law [references]="field.references"
            [field]="field"></tooltip-law>
          }
        </div>
      </div>
      @if (field.description) {
        <div class="common-field-with-button__text-description"
        [innerHTML]="field.description"></div>
      }
    </div>
    <div class="common-field-with-button__buttons-container">
      @if (!isLanding && fieldTypeReport.lastReport) {
        <button class="common-button__text-little-noborder"
          [disabled]="field.noEditable || fieldTypeReport.confidentialLocked"
          (click)="launchActionReport('goToFolder')">
          <span class="common-button__text-little-title"
            [afTranslate]="'field-type-report.go-button'">_Ir a informes</span>
        </button>
      }
      <button class="common-button__text-little-border"
        [disabled]="isLanding || field.noEditable || fieldTypeReport.confidentialLocked"
        (click)="launchActionReport('generateReport')">
        <i class="lf-icon-report common-icon__sm"></i>
        <span class="common-button__text-little-title"
          [afTranslate]="'field-type-report.generate-button'">_Generar informe</span>
      </button>
    </div>
    @if (fieldTypeReport.lastReport) {
      <div class="common-field-with-button__items-block">
        <div class="common-field-with-button__item-container">
          <div class="common-field-with-button__text-container">
            <div class="common-field-with-button__info-line-container">
              <span class="common-field-with-button__label-text">
                <span [afTranslate]="'field-type-report.label-1'">_Última versión del informe</span>:
              </span>
              <button class="common-button__link"
                [disabled]="isLanding || field.noEditable"
                (click)="launchActionReport('viewReport')">
                <span class="common-button__link-text">{{fieldTypeReport.lastReport?.title}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  @if (field.error) {
  <div class="common-text-input__mandatory-tag">
    @if (field.blocker) {
      <i class="lf-icon-warning common-icon__error-md"></i>
    }
    <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
  </div>
  }
</div>
